'use client'

import { useSession } from 'next-auth/react'
import { useEffect } from 'react'

declare global {
  interface Window {
    tidioChatApi?: {
      setVisitorData: (data: { email?: string; name?: string }) => void
    }
  }
}

/**
 * Identifies the logged-in user to the Tidio chat widget.
 * When a user is authenticated, their name and email are passed to Tidio
 * so support agents can see visitor identity in the Tidio dashboard.
 */
export function TidioIdentify() {
  const { data: session } = useSession()

  useEffect(() => {
    if (!session?.user) return

    const { email, name } = session.user

    const identifyUser = () => {
      if (window.tidioChatApi) {
        window.tidioChatApi.setVisitorData({
          email: email || undefined,
          name: name || undefined,
        })
      }
    }

    // Try immediately in case Tidio is already loaded
    identifyUser()

    // Also listen for Tidio ready event in case it loads after this component
    const handleTidioReady = () => identifyUser()
    document.addEventListener('tidioChat-ready', handleTidioReady)

    return () => {
      document.removeEventListener('tidioChat-ready', handleTidioReady)
    }
  }, [session?.user])

  return null
}
